import { action } from 'satcheljs';
import AttachmentWellViewState from 'owa-attachment-well-data/lib/schema/AttachmentWellViewState';

export const setAnnouncedComponentMessage = action(
    'setAnnouncedComponentMessage',
    (attachmentWell: AttachmentWellViewState, message: string) => ({
        attachmentWell,
        message,
    })
);
